let nf = {}

nf.getFlag = (() => {
    var flaglist = [
        {areaid: 1, area: '中国', fname: 'China'},
        {areaid: 2, area: '美国', fname: 'US'},
        {areaid: 3, area: '日本', fname: 'Japan'},
        {areaid: 4, area: '英国', fname: 'UK'},
        {areaid: 5, area: '新加坡', fname: 'Singapore'},
        {areaid: 6, area: '马来西亚', fname: 'Malaysia'},
        {areaid: 7, area: '中国香港', fname: 'HongKong'},
        {areaid: 8, area: '德国', fname: 'Germany'},
        {areaid: 9, area: '澳大利亚', fname: 'Australia'},
        {areaid: 10, area: '奥地利', fname: 'Austria'},
        {areaid: 11, area: '加拿大', fname: 'Canada'},
        {areaid: 12, area: '欧元区', fname: 'Eurozone'},
        {areaid: 13, area: '法国', fname: 'France'},
        {areaid: 14, area: '韩国', fname: 'Korea'},
        {areaid: 15, area: '新西兰', fname: 'NewZealand'},
        {areaid: 16, area: '瑞士', fname: 'Switzerland'},
        {areaid: 17, area: '意大利', fname: 'Italy'},
        {areaid: 18, area: '中国1', fname: 'china1'}
    ];

    return function (area, fesname) {
        var fname = '';
        if (fesname.indexOf('国内无夜盘交易')!=-1) { //特殊处理
            fname = 'china1'
        } else {
            flaglist.forEach(e => {
                if (e.area == area) {
                    fname = e.fname;
                }
            });
        }
        return fname;
    }
})();

export default nf;